export enum SourceRecordAttribution {
  IN_SCOPE = "in_scope",
  OUT_OF_SCOPE = "out_of_scope",
  UNRESOLVED = "unresolved",
}

export const dataBySourceRecordAttribution: Record<
  SourceRecordAttribution,
  { label: string }
> = {
  [SourceRecordAttribution.IN_SCOPE]: { label: "In scope" },
  [SourceRecordAttribution.OUT_OF_SCOPE]: { label: "Out of scope" },
  [SourceRecordAttribution.UNRESOLVED]: { label: "Unresolved" },
}
